<section class="container">
  <div class="header-wrapper">
    <h1 data-qa-id="copyconfig-logs-header">Copy Configuration Logs</h1>
  </div>

  <div class="content-wrapper">
    <a data-qa-id="copyconfig-logs-btn-refresh" mat-raised-button (click)="refreshLogs()" class="provision-log-btn">
      <mat-icon>refresh</mat-icon> Refresh Logs
    </a>
    <br /><br />

    <table data-qa-id="copyconfig-logs-table" mat-table [dataSource]="logEntries" class="mat-elevation-z2">
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="log-header"> Status </th>
        <td mat-cell *matCellDef="let element" class="log-status">
          @if (!element.Finished && !element.HasErrors) {
            <span class="log-ongoing" [attr.data-qa-id]="'copyconfig-logs-status-ongoing-' + element.JobId">Ongoing</span>
          }
          @if (element.HasErrors) {
            <span class="log-fail" [attr.data-qa-id]="'copyconfig-logs-status-failed-' + element.JobId">Failed</span>
          }
          @if (element.Finished && !element.HasErrors) {
            <span class="log-success" [attr.data-qa-id]="'copyconfig-logs-status-success-' + element.JobId">Successful</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef class="log-header"> Date </th>
        <td mat-cell *matCellDef="let element"> {{element.Started | date : "yyyy-MM-dd HH:mm:ss"}} </td>
      </ng-container>

      <ng-container matColumnDef="source">
        <th mat-header-cell *matHeaderCellDef class="log-header"> Source </th>
        <td mat-cell *matCellDef="let element"> Config copied from tenant {{element.SourceTenantName}} </td>
      </ng-container>

      <ng-container matColumnDef="logs">
        <th mat-header-cell *matHeaderCellDef class="log-header"> Logs </th>
        <td mat-cell *matCellDef="let element">
          <a mat-raised-button (click)="goToLog(element.JobId)"
            class="mat-primary provision-log-btn">
            <mat-icon>playlist_play</mat-icon>
          </a>
        </td>
      </ng-container>

      <ng-container matColumnDef="markFailed">
        <th mat-header-cell *matHeaderCellDef class="log-header"> Mark Failed </th>
        <td mat-cell *matCellDef="let element">
          @if (!element.Finished && !element.HasErrors) {
            <a mat-raised-button (click)="markLogAsFailed(element)"
              class="mat-error provision-log-btn"
              matTooltip="Marks this Copy Config as failed so a retry is no longer blocked. It does not stop a run that is still in progress.">
              <mat-icon>flag</mat-icon>
            </a>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</section>
